
export default class VersionNumber {

  private versionString: string;
  public readonly major: number;
  public readonly minor: number;
  public readonly revision: number;

  constructor(version: string) {
    const pattern = /^(\d+)\.(\d+)\.(\d+)$/;
    const result = version.match(pattern);
    if ( !result ) {
      throw new Error('Not a valid version string.');
    }
    this.versionString = version;
    this.major = Number(result[1]);
    this.minor = Number(result[2]);
    this.revision = Number(result[3]);
  }

  public toString(): string {
    return this.versionString;
  }

  public compareTo(other: VersionNumber): number {
    return this.cmp(this.major, other.major, () => {
      return this.cmp(this.minor, other.minor, () => {
        return this.cmp(this.revision, other.revision, () => {
          return 0;
        });
      });
    });
  }

  private cmp(a: number, b: number, equalsAction: () => number): number {
    if ( a === b ) {
      return equalsAction();
    }
    else {
      return this.signum(a - b);
    }
  }

  private signum(value: number): number {
    if ( value < 0 ) {
      return -1;
    }
    if ( value > 0 ) {
      return 1;
    }
    return 0;
  }

}
